<template>
  <el-dialog
    class="radish-dia"
    title="修改密码"
    width="390px"
    height="200px"
    top="70px"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="showClose"
  >
    <div class="radish-dia-body">
      <el-alert :title="title" type="warning" :closable="false"> </el-alert>
      <el-input v-model="pass" size="mini" placeholder="新密码" style="margin: 10px 0"> </el-input>
      <el-alert v-if="msg" :title="msg" type="error" :closable="false"> </el-alert>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data: function() {
    return {
      dialogVisible: false,
      pass: '',
      title: '密码必须包含数字和字母，长度至少8位。',
      showClose: false,
      sending: false,
    }
  },
  computed: {
    msg() {
      if (this.pass) {
        if (this.pass.length < 8) return '密码长度至少8位'
        if (!/\d+/.test(this.pass)) return '密码必须包含数字'
        if (!/[a-zA-Z]+/.test(this.pass)) return '密码必须包含字母'
      }
      return ''
    },
  },
  mounted() {
    if (app.user && app.user.reset) {
      this.dialogVisible = true
      this.title = '当前密码为初始密码，为了账号安全，请及时修改。密码必须包含数字和字母，长度至少8位。'
    }
  },
  methods: {
    handleConfirm: async function() {
      if (this.sending) return this.$message.info('操作中请稍候...')
      if (this.pass) {
        if (this.msg) return this.$message.warning(this.msg)
        this.sending = true
        await app.service('users').patch(app.user._id, {
          password: this.pass,
          reset: false,
        })
        const account = app.user.account
        this.dialogVisible = false
        this.showClose = false
        await app.logout()
        app
          .authenticate({
            account: account,
            password: this.pass,
            strategy: 'local',
          })
          .then(({ accessToken }) => {
            this.sending = false
            this.$message.success('修改成功')
            return app.emit('login', { accessToken })
          })
          .catch(e => {
            this.$msgbox('登录失败！')
            console.log('error')
            return console.log(e)
          })
      } else {
        this.$message.warning('请输入新密码')
      }
    },
  },
}
</script>
